// pages/module-pages/faq/UpdateFaqPage.tsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BaseFaq, Faq } from "../../../types/features/Faq";
import useFaqs from "../../../hooks/features/faqs/useFaqs";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import FaqForm from "../../../components/shared/faqs/FaqForm";
import useCustomParams from "../../../hooks/core/useCustomParams";

export default function UpdateFaqPage() {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const { fetchFaqById, updateFaq } = useFaqs();
  const [faq, setFaq] = useState<Faq | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    loadFaq();
  }, [id]);

  const loadFaq = async () => {
    if (id) {
      const data = await fetchFaqById(id);
      setFaq(data);
      setLoading(false);
    }
  };

  const handleSubmit = async (data: BaseFaq) => {
    setIsLoading(true);
    const slug = data.question
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

    const success = await updateFaq(id!, { ...data, slug });
    setIsLoading(false);
    if (success) {
      navigate("/admin/faq");
      setIsSuccess(true);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <PageLayout title="Modifier une FAQ" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Modifier la FAQ</h1>
          <p className="text-gray-500 mt-1">Modifiez la question ou la réponse</p>
        </div>
        <FaqForm
          isSuccess={isSuccess}
          initialData={faq as Faq}
          isEdit={true}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}
